import {
    ADD_FAVOURITE_SURVEY_GROUP,
    FETCH_ALL_SURVEY_GROUP,
    FETCH_ALL_SURVEY_GROUP_SUCCESS,
    FILTER_SURVEY_GROUP,
    GET_ALL_SURVEY_GROUP,
    GET_UNSELECTED_ALL_SURVEY_GROUP,
    HANDLE_SURVEY_GROUP_REQUEST_CLOSE,
    HIDE_SURVEY_GROUP_LOADER,
    SHOW_SURVEY_GROUP_LOADER,
    ON_ADD_SURVEY_GROUP,
    ON_ALL_SURVEY_GROUP_SELECT,
    ON_SURVEY_GROUP_CLOSE,
    ON_SURVEY_GROUP_SELECT,
    ON_DELETE_SURVEY_GROUP,
    ON_DELETE_SELECTED_SURVEY_GROUP,
    ON_FILTER_SURVEY_GROUP_OPTION_SELECT,
    ON_SAVE_SURVEY_GROUP,
    ON_SAVE_SURVEY_GROUP_SUCCESS,
    ON_TOGGLE_SURVEY_GROUP_DRAWER,
    SHOW_SURVEY_GROUP_MESSAGE,
    UPDATE_SEARCH_SURVEY_GROUP,
    ON_SURVEY_GROUP_QUESTIONS
} from 'constants/ActionTypes';

export const onSurveyGroupQuestions = (data) => {
    return {
        type: ON_SURVEY_GROUP_QUESTIONS,
        payload: data
    };
};
export const fetchSurveyGroups = () => {
    return {
        type: FETCH_ALL_SURVEY_GROUP
    };
};

export const fetchSurveyGroupsSuccess = (data) => {
    return {
        type: FETCH_ALL_SURVEY_GROUP_SUCCESS,
        payload: data
    };
};
export const showSurveyGroupMessage = (message) => {
    return {
        type: SHOW_SURVEY_GROUP_MESSAGE,
        payload: message
    };
};
export const addFavouriteSurveyGroup = (data) => {
    return {
        type: ADD_FAVOURITE_SURVEY_GROUP,
        payload: data
    };
};
export const onSurveyGroupSelect = (data) => {
    return {
        type: ON_SURVEY_GROUP_SELECT,
        payload: data
    };
};
export const onAddSurveyGroup = () => {
    return {
        type: ON_ADD_SURVEY_GROUP,
        payload: ''
    };
};
export const onSurveyGroupClose = () => {
    return {
        type: ON_SURVEY_GROUP_CLOSE,
        payload: ''
    };
};
export const onFilterSurveyGroupOptionSelect = (option) => {
    return {
        type: ON_FILTER_SURVEY_GROUP_OPTION_SELECT,
        payload: option
    };
};
export const onSaveSurveyGroup = (data) => {
    return {
        type: ON_SAVE_SURVEY_GROUP,
        payload: data
    };
};
export const onSaveSurveyGroupSuccess = (data) => {
    return {
        type: ON_SAVE_SURVEY_GROUP_SUCCESS,
        payload: data
    };
};
export const onDeleteSurveyGroup = (data) => {
    return {
        type: ON_DELETE_SURVEY_GROUP,
        payload: data
    };
};
export const onDeleteSelectedSurveyGroup = () => {
    return {
        type: ON_DELETE_SELECTED_SURVEY_GROUP,
        payload: ''
    };
};
export const filterSurveyGroup = (userName) => {
    return {
        type: FILTER_SURVEY_GROUP,
        payload: userName
    };
};
export const getAllSurveyGroup = () => {
    return {
        type: GET_ALL_SURVEY_GROUP,
        payload: ''
    };
};
export const getUnselectedAllSurveyGroup = () => {
    return {
        type: GET_UNSELECTED_ALL_SURVEY_GROUP,
        payload: ''
    };
};
export const onAllSurveyGroupSelect = () => {
    return {
        type: ON_ALL_SURVEY_GROUP_SELECT,
        payload: ''
    };
};
export const updateSearchSurveyGroup = (userName) => {
    return {
        type: UPDATE_SEARCH_SURVEY_GROUP,
        payload: userName
    };
};
export const onToggleSurveyGroupDrawer = () => {
    return {
        type: ON_TOGGLE_SURVEY_GROUP_DRAWER,
    };
};
export const handleSurveyGroupRequestClose = () => {
    return {
        type: HANDLE_SURVEY_GROUP_REQUEST_CLOSE,
    };
};
export const showSurveyGroupLoader = () => {
    return {
        type: SHOW_SURVEY_GROUP_LOADER,
    };
};
export const hideSurveyGroupLoader = () => {
    return {
        type: HIDE_SURVEY_GROUP_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/SurveyGroup.js